import { mockConsultationDB } from './mockDb';
import type { Encounter, EncounterFormData } from '../types';

export const encounterService = {
  async getAll(): Promise<Encounter[]> {
    await new Promise(resolve => setTimeout(resolve, 100));
    return mockConsultationDB.getEncounters();
  },

  async getById(id: string): Promise<Encounter> {
    await new Promise(resolve => setTimeout(resolve, 100));
    const encounter = mockConsultationDB.getEncounter(id);
    if (!encounter) throw new Error('Encounter not found');
    return encounter;
  },

  async create(data: any): Promise<Encounter> {
    await new Promise(resolve => setTimeout(resolve, 200));
    return mockConsultationDB.createEncounter({
      ...data,
      dateTime: new Date().toISOString(),
    });
  },

  async update(id: string, data: Partial<EncounterFormData>): Promise<Encounter> {
    await new Promise(resolve => setTimeout(resolve, 200));
    const updated = mockConsultationDB.updateEncounter(id, data);
    if (!updated) throw new Error('Encounter not found');
    return updated;
  },

  async getTodaysEncounters(): Promise<Encounter[]> {
    await new Promise(resolve => setTimeout(resolve, 100));
    return mockConsultationDB.getTodaysEncounters();
  },

  async getByDoctor(doctorId: string): Promise<Encounter[]> {
    await new Promise(resolve => setTimeout(resolve, 100));
    const allEncounters = mockConsultationDB.getEncounters();
    return allEncounters.filter(encounter => encounter.doctorId === doctorId);
  },

  async getTodaysEncountersByDoctor(doctorId: string): Promise<Encounter[]> {
    await new Promise(resolve => setTimeout(resolve, 100));
    const todaysEncounters = mockConsultationDB.getTodaysEncounters();
    return todaysEncounters.filter(encounter => encounter.doctorId === doctorId);
  },
};
